// extracted by mini-css-extract-plugin
export default {"tabContainer":"tab-panel_tabContainer__O+PTl"};